import { SxProps } from '@mui/material';

export const colorSelectedContainerSx = ({
	isDrawer,
	isMobile,
}: {
	isDrawer?: boolean;
	isMobile?: boolean;
}): SxProps => ({
	padding: '10px',
	margin: isDrawer ? '10px' : '0',
	backgroundColor: 'white',
	border: isDrawer ? 1 : 0,
	borderColor: isDrawer ? 'divider' : '',
	mr: isMobile ? '10px' : '',
});

export const yourColorBoxSx = {
	display: 'flex',
};

export const yourColorTypographySx = {
	flexGrow: 1,
	color: 'grey.500',
};

export const circleContainerSx = {
	display: 'flex',
	alignItems: 'center',
	height: 64,
	overflow: 'hidden',
	py: '10px',
};

export const yourColorCircleSx = ({
	colorRgb,
	isMobile,
}: {
	colorRgb: string;
	isMobile: boolean;
}): SxProps => ({
	width: 50,
	height: 50,
	border: 1,
	borderColor: 'grey.100',
	borderRadius: '50%',
	backgroundColor: colorRgb,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	'&:hover': {
		opacity: !isMobile ? 0.4 : 1,
	},
});

export const youColorCircleStateSx = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	'& .hover-icon': {
		opacity: 0,
		fontSize: '20px',
		cursor: 'pointer',
	},
	'&:hover .hover-icon': {
		opacity: 1,
		cursor: 'pointer',
	},
};

export const yourColorNameContainerSx = {
	display: 'flex',
	flexDirection: 'column',
	paddingLeft: '10px',
	paddingRight: '5px',
	gap: '5px',
};

export const yourColorNameContainerBoxSx = {
	display: 'flex',
};

export const yourColorNameEllipsisSx = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '200px',
};

export const yourColorEditIconSx = {
	minWidth: 0,
	padding: 0,
	backgroundColor: 'white',
	border: 'none',
	boxShadow: 'none',
	color: 'secondary.light',
	marginLeft: 'auto',
	'&:hover': {
		border: 'none',
		boxShadow: 'none',
	},
	'&:focus': {
		outline: 'none',
	},
};
